import React from 'react';
import UI from '../ui';
import Utils from '../utils';

const { Logger, Session, Navigation } = Utils;
const { WrappedButton, WrappedButtonType } = UI;

export const SsoForm = ({ responsiveCls, SSOError }) => {
	const { brandName } = Session.getBrand();
	const { ssoUrl } = Session.getCalculatedSettings();

	const onClickSsoUrl = () => {
		Logger.saveActionData('SSO Sign In Button Clicked');

		Navigation.redirect(ssoUrl);
	};

	const defaultMessage = `You have been signed out of ${brandName}. Click the button below to sign back in.`;
	const ssoMessage =
		'There was an issue connecting to Stamps.com. Please contact your system administrator to make sure your account is set up properly, then try again.';

	return (
		<div className="common-authentication authentication-sso-form">
			<div className="primary-header">{SSOError ? 'Sign-In Error' : 'Signed Out'}</div>
			<p>{SSOError ? ssoMessage : defaultMessage}</p>
			<WrappedButton
				className={`sso-signin ${responsiveCls}`}
				buttonType={WrappedButtonType.Primary}
				label="Sign In"
				onClick={onClickSsoUrl}
				dataqa="signin-button"
			/>
		</div>
	);
};
